import { RefreshCw } from "lucide-react";
import type { MouseEventHandler } from "react";

import { BasicTooltip } from "@/components/ui/Tooltip";
import { cn } from "@/lib/utils";

interface ScorecardRerunIconButtonProps {
  label: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  isRerunning: boolean;
  isDisabled: boolean;
  tooltipContent?: string;
  ariaLabel?: string;
  className?: string;
}

const ScorecardRerunIconButton = ({
  label,
  onClick,
  isRerunning,
  isDisabled,
  tooltipContent,
  ariaLabel,
  className,
}: ScorecardRerunIconButtonProps) => (
  <BasicTooltip content={tooltipContent ?? `Re-run ${label}`} side="top" delayDuration={300}>
    <button
      type="button"
      onClick={onClick}
      disabled={isRerunning || isDisabled}
      aria-label={ariaLabel ?? `Re-run ${label}`}
      className={cn(
        "rounded p-1 text-muted-foreground transition-opacity duration-150 hover:bg-muted hover:text-foreground disabled:cursor-not-allowed group-focus-within:opacity-100 group-hover:opacity-100",
        // Kept subtly visible (rather than fully hidden) so the action stays
        // discoverable without a hover/focus, matching the always-visible
        // rerun affordances used in detail views.
        isRerunning ? "opacity-100 disabled:opacity-100" : "opacity-40 disabled:opacity-40",
        className,
      )}
    >
      <RefreshCw className={cn("h-3.5 w-3.5", isRerunning && "animate-spin")} />
    </button>
  </BasicTooltip>
);

export default ScorecardRerunIconButton;
